<template>
    <div class="modal fade" :id="modalId" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
        :aria-labelledby="modalId" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h1 class="modal-title fs-5" id="staticBackdropLabel">{{ modalTitle }}</h1>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <form @submit.prevent="$parent[modalSubmitFnc](submitParam)">
                <div class="modal-body">
                        <div class="">
                            <h5 class="col-form-label">
                                {{ modalFormLabel }}
                            </h5>
                        </div>
                        <div v-for="(field, i) in inputFields" :key="i" class="input-field my-2 d-inline-flex w-100">
                            <label class="fake-placeholder" >{{ (field.type == 'date') ? field.label : '' }}</label>
                            <input v-if="field.type !== 'select'"
                                v-model="field.value"
                                :type="field.type"
                                :id="field.id"
                                class="w-100 form-control"
                                :placeholder="field.placeholder"
                                :required="field.required"
                                :pattern="(field.pattern) ?? '.*'">
                            <select v-else class="form-select"
                                :id="field.id"
                                v-model="field.value"
                                required>
                                <option value="" data-hidden="true" selected disabled>{{ field.placeholder }}</option>
                                <option v-for="option in field.options" :key="option.id" :value="option.id">
                                    {{ option[field.optionName] }}
                                </option>
                            </select>
                            <span class="" v-if="field.span"> {{ field.span }}</span>
                        </div>
                        <div v-for="(doc, index) in documents" :key="index" class="mb-4">
                            <label :for="'file' + index" class="form-label text-start">{{
                            doc.name
                            }}</label>
                            <input type="file" :id="'file' + index" @change="handleFileChange($event, index)" class="form-control" />
                            <img v-if="doc.preview" :src="doc.preview" class="thumbnail" height="250px" />
                        </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">{{ $t("close") }}</button>
                    <button type="submit" id="new-email-submit" :data-bs-dismiss="dismissable"  class="btn btn-primary">
                        {{ $t(modalSubmitText) }}
                    </button>
                </div>
            </form>
            </div>
        </div>


    </div>
</template>

<script>
import router from '@/router';

export default {
    name: "GeneralModal",
    props: {
        modalId: {
            default: "staticGeneralModal",
            type: String
        },
        modalTitle: String,
        modalFormLabel: String,
        inputFields: Object,
        documents: {
            default: [],
            type: Array
        },
        // modalPlaceholder : String,
        modalSubmitText: {
            default: "submit",
            type: String
        },
        modalSubmitFnc: {
            default: "modalSubmitFnc",
            type: String
        },
        submitParam: {
            default: null,
            type: String
        },
        dismissable: {
            default: "modal",
            type: String
        }
    },
    methods: {
        /** */
        handleFileChange(event, index) {
          const file = event.target.files[0];
          if (file && file.type.startsWith("image/")) {
            this.documents[index].file = file;
            const reader = new FileReader();
            reader.onload = (e) => {
              this.documents[index].preview = e.target.result;
            };
            reader.readAsDataURL(file);
          }
        },
        /****************************/
        /** */
        submitModal() {
            router.push({ name: 'applicant' })
        }
    }
}
</script>